export const LotusMark = ({ className = "", stroke = "#2F332B" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* petals */}
    <path d="M32 54c-9-4-15-12-15-20 0-3 1-6 3-8 2 6 7 10 12 12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32 54c9-4 15-12 15-20 0-3-1-6-3-8-2 6-7 10-12 12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    {/* central mother/starflower form */}
    <path d="M32 52c-6-6-9-13-9-21 0-8 4-15 9-21 5 6 9 13 9 21 0 8-3 15-9 21Z" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round"/>
    <circle cx="32" cy="28" r="3.4" stroke={stroke} strokeWidth="1.6"/>
    <path d="M32 24.6v6.8M28.6 28h6.8" stroke={stroke} strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

export const Wordmark = ({ dark = false, className = "" }) => {
  const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_asmi-gynae/artifacts/slu2xfkj_asmi%20logo%20finak.jpeg";
  return (
    <div className={`flex items-center ${className}`} data-testid="brand-wordmark">
      <img
        src={LOGO}
        alt="Asmi Women Health & Infertility Clinic"
        className={`h-16 w-auto object-contain ${dark ? "rounded-2xl bg-cream/95 p-2 shadow-lg" : ""}`}
      />
    </div>
  );
};
